import createFetchClient from "openapi-fetch";
import type { paths } from "../generated/schema";
import { SESSION_TOKEN_KEY } from "./use-session-token";

// Pluggable config — call before any API requests are made (e.g. at app init in baback-office).
// In customer-facing contexts (standalone widget) these defaults are used as-is.
let _getMerchantToken: () => string | null = () => null;
let _baseUrl = "https://api2.baback.co/";

export function configureMerchantToken(getter: () => string | null) {
  _getMerchantToken = getter;
}

export function configureReturnWidgetBaseUrl(url: string) {
  _baseUrl = url;
  _client = null; // invalidate so next call rebuilds with new URL
}

let _client: ReturnType<typeof createFetchClient<paths>> | null = null;

function buildClient() {
  return createFetchClient<paths>({
    baseUrl: _baseUrl,
    credentials: "include",
    fetch: async (input, init = {}) => {
      const headers = new Headers((init as RequestInit).headers);

      // Inject merchant Bearer token on unauthenticated calls (e.g. load-with-items).
      // Calls that already set a session token explicitly are left untouched.
      const existing = headers.get("authorization") ?? "";
      if (!existing || existing === "Bearer ") {
        const merchantToken = _getMerchantToken();
        if (merchantToken) {
          headers.set("authorization", `Bearer ${merchantToken}`);
        }
      }

      const response = await fetch(input as RequestInfo, {
        ...(init as RequestInit),
        headers,
      });

      // Store the order session JWT for subsequent calls.
      const data = await response.clone().json().catch(() => null);
      const token = data?.token ?? data?.data?.token;
      if (token) {
        localStorage.setItem(SESSION_TOKEN_KEY, token.slice(0, -12));
      }

      return response;
    },
  });
}

export function getReturnWidgetFetchClient() {
  if (!_client) _client = buildClient();
  return _client;
}
